import React, { FC } from 'react'
import { t } from '@lingui/macro'
import { Flex } from '@chakra-ui/react'

import PageHeader from 'front-end/src/components/common/page/header/PageHeader'
import { Page } from 'front-end/src/components/common/page/Page'

import { CertificateTemplatePreview } from './CertificateTemplatePreview'
import { useParams } from 'react-router'

export const CertificateTemplatePreviewPage: FC = () => {
  const params = useParams<{
    templateId: string
  }>()
  const templateId = parseInt(params.templateId)

  return (
    <Page>
      <PageHeader className="PageHeader" title={t`Preview of a certificate`} />
      <Flex mt={'40px'} justifyContent="center">
        <CertificateTemplatePreview templateId={templateId} />
      </Flex>
    </Page>
  )
}
